import { createSlice } from '@reduxjs/toolkit';

export const requestCommentSlice = createSlice({
    name: 'requestComment',
    initialState: {
        isShowComment: false,
        patientInfoComment: null,

        requestCommentLog: null,

        treatmentPlanComment: null,
        treatmentPlanAccordion: {
            expanded: false,
            planNumber: null,
            planId: null,
        },
        isEditedValueInPatientInfo: false,
        triggerRefetch: 0,
    },
    reducers: {
        toggle: (state, action) => {
            //Purpose: Comment toggle button
            state.isShowComment = action.payload;
        },
        setPatientInfoComment: (state, action) => {
            state.patientInfoComment = action.payload;
        },
        setTreatmentPlanComment: (state, action) => {
            state.treatmentPlanComment = action.payload;
        },
        setRequestCommentLog: (state, action) => {
            state.requestCommentLog = action.payload;
        },
        setIsEditedValueInPatientInfo: (state, action) => {
            state.isEditedValueInPatientInfo = action.payload;
        },
        handleTriggerRefetch: (state, action) => {
            state.triggerRefetch = state.triggerRefetch + 1;
        },
    },
});

export const {
    toggle,
    setPatientInfoComment,
    setTreatmentPlanComment,
    setRequestCommentLog,
    setIsEditedValueInPatientInfo,
    handleTriggerRefetch,
} = requestCommentSlice.actions;
export default requestCommentSlice.reducer;
